import React from "react";
import Faq from "react-faq-component";

const styles = {
  titleTextColor: "#4d4d4d",
  rowTitleColor: "#403F58",
  rowContentColor: "grey",
  fontFamily: "Khula, sans-serif",
  color: "#403F58",
};

const config = {
  animate: true,
  arrowIcon: "⌄",
};

const BasicModule = ({ modules }) => {
  if (!modules || modules.length === 0) return null;

  // Each module becomes one FAQ row, with points as a list
  const faqRows = modules.map((module) => ({
    title: module.title,
    content: (
      <ul style={{ paddingLeft: 20 }}>
        {module.content
          .split("\n")
          .filter((line) => line.trim() !== "")
          .map((point, idx) => (
            <li key={idx} style={{ marginBottom: "12px" }}>
              {point}
            </li>
          ))}
      </ul>
    ),
  }));

  const data = { rows: faqRows };

  return (
    <div>
      <ul className="mt-4">
        <h4
          style={{ fontFamily: "Josefin Sans, sans-serif" }}
          className="text-xl text-slate-800 text-center extraBold"
        >
          Course Module:
        </h4>
        <Faq data={data} styles={styles} config={config} />
      </ul>
    </div>
  );
};

export default BasicModule;
